export default __webpack_public_path__ + "9fc745f328351fb0d0679975cd97bbca.webp";